import { getFormattedFinance } from 'cng-common/helpers/numbers'
import { Nullable } from 'cng-common/models/utils'

const MILLION = 1_000_000
export const getFormattedRevenue = (revenue?: Nullable<number>, isFull: boolean = false) => {
  if (revenue === null || revenue === undefined) {
    return '-'
  }

  const converted = revenue / MILLION
  if (isFull) {
    let [, decimal] = converted.toString().split('.')
    if (!decimal) {
      decimal = ''
    }

    return getFormattedFinance(converted, {
      minimumFractionDigits: decimal.length,
      maximumFractionDigits: decimal.length,
    })
  }

  return getFormattedFinance(converted, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })
}
